import React from 'react';
import { useSelector } from 'react-redux';

const Sidebar = ({ activeSection, onSectionChange, user, onLogout, isMobile, isOpen, onClose }) => {
  const { teamsuser } = useSelector(state => state.teamsAuth);
  const menuItems = [
    { id: 'dashboard', icon: '🎮', label: 'Games & Trivia' },
    { id: 'billing', icon: '💳', label: 'Billing Dashboard' },
    // { id: 'engagement', icon: '📊', label: 'Engagement Report' },
    { id: 'blog', icon: '📝', label: 'Ricotta Blog' }
  ];

  return (
    <div className="sidebar" style={{
      width: '250px',
      height: '100vh',
      backgroundColor: '#ffffff',
      borderRight: '1px solid #e0e0e0',
      position: 'fixed',
      left: isMobile ? (isOpen ? '0' : '-250px') : '0',
      top: '0',
      zIndex: '1000',
      display: 'flex',
      flexDirection: 'column',
      transition: isMobile ? 'left 0.3s ease-in-out' : 'none'
    }}>
      {/* Logo - Hidden on mobile since it's in the header */}
      {!isMobile && (
        <div style={{
          padding: '1.5rem 1rem',
          borderBottom: '1px solid #e0e0e0',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem'
        }}>
          <img src="/assets/cheese-512.png" width={32} alt="Ricotta" />
          <span style={{ 
            fontWeight: 'bold', 
            fontSize: '1.1rem',
            color: '#E04F60' 
          }}>
            Ricotta Dashboard
          </span>
        </div>
      )}

      {/* Mobile Close Button */}
      {isMobile && (
        <div style={{
          padding: '1rem',
          borderBottom: '1px solid #e0e0e0',
          display: 'flex',
          justifyContent: 'flex-end'
        }}>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '1.5rem',
              color: '#6c757d',
              cursor: 'pointer',
              padding: '0.25rem'
            }}
          >
            ✕
          </button>
        </div>
      )}

      {/* Navigation */}
      <nav style={{ flex: '1', padding: '1rem 0' }}>
        {menuItems.map((item) => (
          <button
            key={item.id}
            onClick={() => onSectionChange(item.id)}
            style={{
              width: '100%',
              padding: '0.75rem 1rem',
              border: 'none',
              backgroundColor: activeSection === item.id ? 'rgba(224, 79, 96, 0.1)' : 'transparent',
              color: activeSection === item.id ? '#E04F60' : '#6c757d',
              textAlign: 'left',
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem',
              cursor: 'pointer',
              transition: 'all 0.2s',
              fontSize: '0.95rem',
              fontWeight: activeSection === item.id ? '600' : '400'
            }}
            onMouseOver={(e) => {
              if (activeSection !== item.id) {
                e.target.style.backgroundColor = 'rgba(224, 79, 96, 0.05)';
              }
            }}
            onMouseOut={(e) => {
              if (activeSection !== item.id) {
                e.target.style.backgroundColor = 'transparent';
              }
            }}
          >
            <span style={{ fontSize: '1.1rem' }}>{item.icon}</span>
            {item.label}
          </button>
        ))}
      </nav>

      {/* User Info & Logout */}
      <div style={{
        padding: '1rem',
        borderTop: '1px solid #e0e0e0',
        marginTop: 'auto'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '0.5rem'
        }}>
          <div style={{ fontSize: '0.85rem', color: '#6c757d' }}>
            <div style={{ fontWeight: '600', color: '#333' }}>
              {teamsuser?.user?.displayName || teamsuser?.user?.name || 'User'}
            </div>
            <div>{teamsuser?.user?.email || teamsuser?.user?.userPrincipalName || 'user@company.com'}</div>
          </div>
        </div>
        <button
          onClick={onLogout}
          style={{
            width: '100%',
            padding: '0.5rem',
            border: '1px solid #E04F60',
            backgroundColor: 'transparent',
            color: '#E04F60',
            borderRadius: '6px',
            fontSize: '0.85rem',
            cursor: 'pointer',
            transition: 'all 0.2s'
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = '#E04F60';
            e.target.style.color = 'white';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = 'transparent';
            e.target.style.color = '#E04F60';
          }}
        >
          Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;

